import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 3.37c.712 0 1.417.338 1.844.985l.093.155 7.135 12.764c.201.355.297.73.297 1.103 0 1.204-.801 2.17-2.075 2.249l-.169.005H4.875c-1.372 0-2.244-.997-2.244-2.254 0-.311.066-.623.21-.918L10.064 4.51A2.189 2.189 0 0 1 12 3.37zm-.005 11.99a1.05 1.05 0 1 0 0 2.1 1.05 1.05 0 0 0 0-2.1zM12 8h-.04a.96.96 0 0 0-.917.887L11.042 9l.177 4.252a.782.782 0 0 0 1.551.102l.011-.102.178-4.292A.96.96 0 0 0 12 8z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }